import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { api } from '../../services/api';
import ImageUploader from '../../components/ImageUploader';
import ProgressBar from '../../components/ProgressBar';
import { Input, TextArea } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;
  label { display: block; margin-bottom: 0.5rem; font-weight:500; }
`;

const LinkRow = styled.div`
  display: flex; gap: 1rem; margin-bottom: 0.5rem;
  align-items: center;
`;

const DonateAdmin = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [progress, setProgress] = useState(0);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const res = await api.get('/donate');
      setData(res);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/donate', data);
      setMsg('Saved successfully');
    } catch (err) { setMsg('Error saving'); }
    finally { setSaving(false); }
  };

  const handleImage = async (file) => {
    if (!file) return;
    setProgress(0);
    const timer = setInterval(() => {
        setProgress(prev => {
            if(prev < 90) return prev + 10;
            return prev;
        });
    }, 100);

    try {
        const fd = new FormData(); fd.append('image', file);
        const res = await api.upload('/donate/image', fd);
        
        clearInterval(timer);
        setProgress(100);
        
        setData(res);
        setTimeout(() => setProgress(0), 500);
    } catch (err) {
        clearInterval(timer);
        setProgress(0);
        console.error('Image upload failed', err);
    }
  };

  const handleAddLink = () => {
    setData({...data, otherLinks: [...data.otherLinks, { name: '', url: '' }]});
  };

  const handleLinkChange = (idx, field, val) => {
    const newLinks = [...data.otherLinks];
    newLinks[idx][field] = val;
    setData({...data, otherLinks: newLinks});
  };

  const removeLink = (idx) => {
    const newLinks = data.otherLinks.filter((_, i) => i !== idx);
    setData({...data, otherLinks: newLinks});
  };

  if (loading) return <div>Loading...</div>;

  return (
    <Container>
      <h2>Manage Donate Page</h2>
      {msg && <div style={{color:'green'}}>{msg}</div>}
      
      <Card style={{marginBottom:'2rem'}}>
        <CardContent>
          <h3>Header</h3>
          <FormGroup><label>Title</label><Input value={data.title} onChange={e=>setData({...data, title:e.target.value})} /></FormGroup>
          <FormGroup><label>Description</label><TextArea value={data.description} onChange={e=>setData({...data, description:e.target.value})} /></FormGroup>
          <ImageUploader previewUrl={data.image} onImageSelect={handleImage} />
          {progress > 0 && <ProgressBar progress={progress} />}
        </CardContent>
      </Card>

      <Card style={{marginBottom:'2rem'}}>
        <CardContent>
           <h3>Donation Info</h3>
           <FormGroup><label>Info Text</label><TextArea value={data.infoText} onChange={e=>setData({...data, infoText:e.target.value})} /></FormGroup>
           <FormGroup><label>PayPal Link</label><Input value={data.paypalLink} onChange={e=>setData({...data, paypalLink:e.target.value})} /></FormGroup>
           <FormGroup><label>Stripe Link</label><Input value={data.stripeLink} onChange={e=>setData({...data, stripeLink:e.target.value})} /></FormGroup>
           
           <h4>Other Links</h4>
           {data.otherLinks.map((link, idx) => (
             <LinkRow key={idx}>
               <Input placeholder="Name" value={link.name} onChange={e=>handleLinkChange(idx, 'name', e.target.value)} />
               <Input placeholder="URL" value={link.url} onChange={e=>handleLinkChange(idx, 'url', e.target.value)} />
               <Button onClick={()=>removeLink(idx)} $variant="danger">x</Button>
             </LinkRow>
           ))}
           <Button onClick={handleAddLink} $variant="secondary">Add Link</Button>
        </CardContent>
      </Card>
      
      <Button onClick={handleSave} disabled={saving}>
        {saving ? 'Saving...' : 'Save All Changes'}
      </Button>
    </Container>
  );
};

export default DonateAdmin;
